import React from 'react';
import Styles from './Footer.module.scss';

export default function Footer() {
  const { Footer } = Styles;
  return (
    <div className={Footer}>
      <h6>SQM VITAS Brasil © 2019 - Todos os direitos reservados</h6>
      <div />
    </div>
  );
}
